import React from "react";
import NavBar from "../NavBar";
import Footer from "../Footer";
import About from "./About";

export default function AboutPage() {
  return (
    <>
      <NavBar border="true" />
      <About />
      <Footer />
    </>
  );
}
